export const RATIO_Inches_EMUs = 914400 // 1英寸 = 914400EMUs
export const RATIO_Inches_Points = 72 // 1英寸 = 72pt
export const RATIO_EMUs_Points = RATIO_Inches_Points / RATIO_Inches_EMUs // 1EMUs = (72 / 914400)pt